<template>
    <form v-if="form" @submit.prevent="submitForm" @input="onFormChange">
        <my-input
            v-model="form.name"
            name="name"
            :error="form.errors.get('name')"
            :autofucos="true"
            class="mb-6"
            label="Name"
            placeholder="Your or your company's full name"
        />

        <my-input
            v-model="form.email"
            name="email"
            :error="form.errors.get('email')"
            :autofucos="true"
            class="mb-6"
            label="Email Address"
            placeholder="Your Email Address"
        />

        <my-input
            v-model="form.username"
            name="username"
            :error="form.errors.get('username')"
            :autofucos="true"
            class="mb-6"
            label="Username"
            placeholder="Your own username"
        />

        <div class="flex flex-col mb-6">
            <label for="user_type" class="font-bold mb-2">Account Type</label>
            <div>
                <div class="flex btn-group btn-group-toggle" data-toggle="buttons">
                    <label class="flex items-center mr-6">
                        <input v-model="form.user_type" type="radio" class="mr-2" value="individual" />
                        <span>Individual</span>
                    </label>
                    <label class="flex items-center">
                        <input v-model="form.user_type" type="radio" class="mr-2" value="company" />
                        <span>Company</span>
                    </label>
                </div>
                <span v-if="form.errors.has('user_type')" class="mt-1 text-xs text-italic mt-1 text-red-500">
                    {{ form.errors.get('user_type') }}
                </span>
            </div>
        </div>

        <div class="flex flex-col mb-6">
            <label for="user_type" class="font-bold mb-2">Email Notification</label>
            <div>
                <div class="flex btn-group btn-group-toggle" data-toggle="buttons">
                    <label class="flex items-center mr-6">
                        <input
                            v-model="form.notification_setting"
                            :value="form.notification_setting"
                            type="checkbox"
                            class="mr-2"
                        />
                        <span>Email</span>
                    </label>
                </div>
                <span v-if="form.errors.has('notification_setting')" class="mt-1 text-xs text-italic mt-1 text-red-500">
                    {{ form.errors.get('notification_setting') }}
                </span>
            </div>
        </div>

        <div class="mb-6">
            <span class="font-bold">Login Info</span>
            <p>You can change your password using below link.</p>
            <a :href="`/users/${user.id}/account/update-password`">Change Password</a>
        </div>

        <my-button :loading="submitting" class="btn btn-primary btn-lg btn-block rounded-full" @click="submitForm">
            <i class="fa fa-save"></i> Save My Changes
        </my-button>
    </form>
</template>

<script>
import Form from '../../forms/form';

export default {
    props: {
        userId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            user: null,
            form: null,
            submitting: false
        };
    },

    mounted() {
        this.fetchUser();
    },

    methods: {
        fetchUser() {
            axios.get(`/api/users/${this.userId}`).then(response => {
                this.user = response.data.data;
                this.updateFormData();
            });
        },

        updateFormData() {
            this.form = new Form({
                name: this.user.name,
                email: this.user.email,
                username: this.user.username,
                user_type: this.user.user_type,
                notification_setting: this.user.notification_setting.email
            });
        },

        submitForm() {
            this.submitting = true;

            this.form
                .put(`/api/users/${this.userId}`)
                .then(response => {
                    this.user = response.data.data;
                    flash.success();
                })
                .catch(() => flash.error({ message: 'It seems like you have submitted invalid data.' }))
                .then(() => (this.submitting = false));
        },

        onFormChange(event) {
            this.form.errors.clear(event.target.name);
        }
    }
};
</script>
